import { toast } from "react-toastify";
import {
  fetchCreateTransferRequest,
  fetchCreateTransferSuccess,
  fetchCreateTransferFailure,
} from "./reducer";
import { CREATE_TRANSFER } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const createTransfer =
  (referenceId, jsonObj, setLoading, onSuccess) =>
  async (dispatch) => {
    dispatch(fetchCreateTransferRequest());

    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        CREATE_TRANSFER(referenceId),
        "POST",
        jsonObj
      );

      if (response?.error) {
        dispatch(fetchCreateTransferFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchCreateTransferSuccess(response));
        dispatch(setSuccessMessage(true));
        toast.success("Products are transferred successfully");
        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(fetchCreateTransferFailure("Something went wrong"));

      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };